import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ApiEndpoints } from './api.constant';

@Injectable()
export class GoogleAPIService {
  private readonly http = inject(HttpClient);

  public getTimeZone(latitude: number, longitude: number): any {
    let currentTimeStamp = Math.floor(new Date().getTime() / 1000);

    return this.http.get(
      `${environment.mainapiUrl}${ApiEndpoints.CommonApis.GetGoogleTimeZone}?latitude=${latitude}&longitude=${longitude}&currentTimeStamp=${currentTimeStamp}`,
      //`${environment.mainapiUrl}/Common/GetGoogleTimeZone?latitude=${latitude}&longitude=${longitude}&currentTimeStamp=${currentTimeStamp}`,
    );
  }

  public getFullAddress(latitude: number, longitude: number): any {
    return this.http.get(
      `${environment.mainapiUrl}${
        ApiEndpoints.CommonApis.GetAddressByGoogleGeoCode
      }?latitude=${encodeURIComponent(latitude)}&longitude=${encodeURIComponent(
        longitude,
      )}`,
      //`${environment.mainapiUrl}/Common/GetAddressByGoogleGeoCode?latitude=${latitude}&longitude=${longitude}`,
    );
  }
}
